<template>
  <div>
    <div :class="$style['popover']">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="scss" module>
.popover {
  $arrow-height: 12px;

  position: relative;
  padding: 16px 24px;
  margin-bottom: $arrow-height;
  background: $color-surface-primary;
  border-radius: $border-radius-rounder;
  filter: drop-shadow(0 2px 6px $color-shadow);

  &::before {
    position: absolute;
    top: 100%;
    left: 50%;
    display: block;
    width: 24px;
    height: $arrow-height;
    background-color: $color-surface-primary;
    clip-path: polygon(0 0, 100% 0, 50% 100%);
    content: '';
    transform: translateX(-50%);
  }
}
</style>
